import { css } from '@emotion/core';

export default ({ classes, cybs }) => ({
  wrapper: css`
    margin-bottom: 0.125rem;
    color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
  `,
  label: css`
    ${classes?.structure?.margin?.space?.right?.[1] || 'margin-right: 0.5rem;'}
    word-break: break-word;
    font-weight: 600;
  `,
  value: css`
  word-break: break-word;
  `
});
